import React from 'react';

import { useComponentParamsContext } from 'lib/context/ComponentParamsContext/ComponentParamsContext';

import Icon from 'components/shared/Icon/Icon';

const Actions = ({ data }) => {
  const { onDelete } = useComponentParamsContext();

  return (
    <div className="flex h-full items-center justify-center">
      <Icon icon="trash-mono" size={14} onClick={() => onDelete(data)} />
    </div>
  );
};

export default Actions;
